import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/PanoramaLine/PanoramaLine.css';

export const prototypeName = 'GLOdwKxn2bC59enGPlogIVGrr4WX9kSZKoAoZx2oIk7OG0Pk6yUy6vk724n2F5Kp3GNq67Hgn';
export {styles};